<style>
 .th{
    font-size: 14px;
     }
</style>
<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-sm-12">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">User List</h4>
                  </div>
               </div>

               <div class="card-body">
                  <div class="row justify-content-between">
                     <div class="col-10 col-sm-10 col-md-6">
                        <div id="user_list_datatable_info" class="dataTables_filter">
                           <form class="mr-3 position-relative">
                              <div class="form-group mb-0">
                                 <input type="text" id="inputSearch" class="form-control" placeholder="Username" v-model="search">
                              </div>
                           </form>
                        </div>
                     </div>
                     <div class="d-flex flex-row-reverse align-items-center col-2 col-sm-2 col-md-6">
                        <b-button variant="outline-primary" class="mx-2 border-none d-flex align-items-center" v-on:click="redirectAdd"><i class="las la-plus-square h4 m-0 p-0"></i></b-button>
                     </div>
                  </div>

                  <data-tables-server :data="filteredUser" :total="dataCount" @size-change="handleSizeChange" @current-page-change="handleCurrentChange" @sort-change="sortChange">
                        <el-table-column prop="id" label="ID" width="60" header-align="center" align="right">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.id}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="user" label="User" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.username}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="role" label="Role" min-width="100" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.role_name}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="merchant" label="Merchant" min-width="100" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.merchant_code}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="loginTime" label="Last Login Time" min-width="150" header-align="center" align="right">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope">{{scope.row.login_time}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="loginIp" label="Last Login IP" min-width="120" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.login_ip != null">{{scope.row.login_ip}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="language" label="Language" min-width="110" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.language}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="status" label="Status" min-width="110" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.status}}</span>
                           </template>
                        </el-table-column>                        
                        <el-table-column prop="createdBy" label="Created By" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.create_by">{{scope.row.create_by}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="createdDate" label="Created Date" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.create_date">{{scope.row.create_date}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="updatedBy" label="Updated By" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.update_by != null">{{scope.row.update_by}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="updatedDate" label="Updated Date" min-width="150" header-align="center" align="left">
                           <template scope="scope">
                              <span class="text-truncate" v-if="scope.row.update_date != null">{{scope.row.update_date}}</span>
                              <span class="text-truncate" v-else>-</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="action" label="Action" min-width="80" header-align="center" align="center">
                           <template scope="scope">
                              <a class="iq-bg-primary" v-b-tooltip.top title="Edit" v-bind:href="'/user/edit?id=' + scope.row.id"><i class="ri-pencil-line mr-1"></i></a>
                              <a class="iq-bg-primary" href="javascript:void()" v-b-tooltip.top title="Delete" :id=scope.row.id @click="deleteUser(scope.row.id)"><i class="ri-delete-bin-line mr-1"></i></a>
                           </template>
                        </el-table-column>
                  </data-tables-server>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import moment from 'moment';

const URL = require("../../../../../config");
locale.use(lang);

Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.use(DataTablesServer);
Vue.prototype.moment = moment;

export default {
   name:'UserList',
   data() {
      return {
         list: [],
         dataCount: 0,
         currentPage: 1,
         pageSize: 20,
         order: {
            column: null,
            order: null
         },
         search: ''
      }
   },
   async mounted() {
      await this.getData();
   },
   methods: {
      async getData() {
         try {
            let response = await axios.get(URL.api.URL + '/api/userList', { 
               params: {
                  m: this.$route.meta.uid,
                  pageno: this.currentPage,
                  limit: this.pageSize,
                  ordercolumn: this.order.column,
                  order: this.order.order
               }
            });
            this.list = response.data.user_list.rows;
            this.dataCount = response.data.user_list.count;
         } catch(error) {
            alert("Error: Retrieve user data error");
            console.log("Error: ", error);
         }
      },
      async deleteUser(id) {
         try {
            if(confirm("Are you sure you want to remove this record?")) {
               await axios.delete(URL.api.URL + '/api/deleteUser', { params: { id: id, m: this.$route.meta.uid } });
               let response = await axios.get(URL.api.URL + '/api/userList', { params: { m: this.$route.meta.uid } });
               this.list = response.data.user_list;
               alert("Delete successful")
               location.reload();
            }
         } catch(error) {
            alert("Error: Delete record error");
            console.log("Error: ", error);
         }
      },
      async redirectAdd() {
         this.$router.push({path: '/user/add'});
      },
      handleSizeChange: async function(val) {
         this.pageSize = val;
         await this.getData();
      },
      handleCurrentChange: async function(val) {
         this.currentPage = val;
         await this.getData();
      },
      sortChange: async function(sortProps) {
         this.order.column = sortProps.prop;
         this.order.order = sortProps.order;

         await this.getData();
      }
   },
   computed:{
        filteredUser: function() {
            return this.list.filter((item) => {
               return item.username.toLowerCase().match(this.search.toLowerCase());
            })
        },
    }
}
</script>